
import logo from "../src/Assets/Images/logo.svg"
import logoEquinox from "../src/Assets/Images/logo.png";
import logoDemmy from "../src/Assets/Images/logo.png";
import logoOcay from "../src/Assets/Images/Ocay.png";
import logoEzims from "../src/Assets/Images/Ezims.svg";
import logoHamed from "../src/Assets/Images/Hamed.png";
import logoEquinoxPrivacy from "../src/Assets/Images/Equinox.png";
import logoOlumajekPrivacy from "../src/Assets/Images/Olumajek.png";

const faviconLogoOcay = './Ocay.png';

const BRANDING = {
  equinox: {
    brandName: "Equinox",
    businessName: "equinox", 
    logo: logoEquinox,
    favicon: logoEquinox,
    privacyLogo: logoEquinoxPrivacy,
    color: {
      primary: "#1C0F5E",
      secondary: "#A89DF1",
    },
  },
  ocay: {
    brandName: "Olumajek IT Continental",
    businessName: "Olumajek_IT_Continental_LTD", 
    logo: logoOlumajekPrivacy,
    favicon: logoOlumajekPrivacy,
    privacyLogo: logoOlumajekPrivacy,
    color: {
      primary: "#161032",
      secondary: "#A2D6F9",
    },
  },
  ezims: {
    brandName: "Emmanuel Ezims Enterprise",
    businessName: "Emmanuel", 
    logo: logoEzims,
    favicon: logoEzims,
    color: {
      primary: "#2563EB",
      secondary: "#F97316",
    },
  },
  alhamedglobal: {
    brandName: "ALHAMED OLA GLOBAL TELECOM LTD",
    businessName: "alhamed", 
    logo: logoHamed,
    favicon: logoHamed,
    color: {
      primary: "#0000FF",
      secondary: "#A2D6F9",
    },
  },
  demmy: {
    brandName: "Demmy",
    businessName: "", 
    logo: logoDemmy,
    favicon: logoDemmy,
    color: {
      primary: "#2948CE",
      secondary: "#21ADE3",
    },
  },
  default: {
    brandName: "Topupbox",
    businessName: "Topupbox",
    logo: logo,
    favicon: logo,
    color: {
      primary: "#2B3C96",
      secondary: "#f0fbff",
    },
  },
};

export default BRANDING;
